<template>
  <div class="tables-basic">
    <div v-if="loading" class="page-loading-container">
      <b-spinner label="Loading..." ></b-spinner>
    </div>
    <div v-else>
      <h2 class="page-title">Integrations</h2>
      <b-row >
        <b-col>
          <Widget
                  title="Github"
          >
            <b-alert show variant="secondary">You can run PageWatch as part of your continuous integration process.<br>
            <a href="https://docs.pagewatch.dev/guide/github.html">Documentation</a></b-alert>
            <div v-if="integrations['github_app']">
              Installed: (App ID: <a :href="`https://github.com/settings/installations/${integrations['github_app']['data']['installation_id']}`">{{integrations['github_app']['data']['installation_id']}}</a>)
            </div>
            <div v-else><b-button size="sm" style="white-space: nowrap;" href="https://github.com/apps/pagewatch-dev">Install Github integration</b-button>
              &nbsp; <small> Be sure to grant access to the relevant repositories.</small></div>


          </Widget>
        </b-col>
      </b-row>
      <b-row >
        <b-col>
          <Widget
                  title="Netlify"
          >
            <b-alert show variant="secondary">
              If you host your website with Netlify you can use our <a href="https://github.com/pagewatchdev/netlify-plugin-pagewatch">netlify integration</a> to automatically run audits on deploy previews.
              <br>
            <a href="https://docs.pagewatch.dev/guide/netlify.html">Documentation</a></b-alert>
          </Widget>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import Widget from '@/components/Widget/Widget';
  import gql from "graphql-tag";
  import { ApolloClient } from "apollo-client";

  import { mapState } from 'vuex';
  import axios from "axios";
  export default {
    name: 'Tables',
    components: { Widget },
    data() {
      return {
        websites: [],
        plan: {},
        toastOptions: {
          theme: 'dark',
          position: 'bottomLeft',
        },
        loading: true,
        integrations: {},
      };
    },
    computed: {
      ...mapState({activeSite: 'activeSite', user: 'user'}),
    },
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Integrations - PageWatch.dev',
      // all titles will be injected into this template
    },
    methods: {
      loadIntegrations(){
        axios
                .get(`integrations`)
                .then(
                        response => {
                          this.integrations = response.data.integrations;
                          this.loading = false;
                          return true;
                        },
                        error => {
                          this.submitting = false;
                          return false;
                        }
                );
      }
    },
    created() {
      if (this.$route.params.integration){
        axios
                .post(`integration/callback/${this.$route.params.integration}`, {
                  installation_id: this.$route.query.installation_id,
                })
                .then(
                        response => {
                          this.$router.push({name: "AdminIntegrationsPage"});
                          return this.loadIntegrations();
                        },
                        error => {
                          this.submitting = false;
                          return false;
                        }
                );
      }
      else{
        this.loadIntegrations();
      }


      this.$watch("$route",() => { this.currentPage = this.$route.query.page || 1}, {
        immediate: true
      });


    }
  };
</script>

<style src="./Api.scss" lang="scss" scoped />
<style lang="scss">
  .link-redirect {
    font-size:9pt;
    color:gray;
    padding:4px;
  }
  .link-status-redirect{
    color:red;
    font-size:9pt;
    padding:4px;
  }
  .link-entry{
    max-width:580px;
    overflow:auto;
  }
  .broken-link-preview-image {
    border-radius: 50%;
    max-width: 250px;
    box-shadow: #bdc4e0 0px 0px 20px;
  }
</style>
